export const SORT_STATE_NONE = 'none'
export const SORT_STATE_ASC = 'asc'
export const SORT_STATE_DESC = 'desc'

// none, asc, desc
export const TOGGLE_TYPE_NAD = 'nad'
// asc, desc
export const TOGGLE_TYPE_AD = 'ad'
